const TEST_IDS = {
  symbol: 'vault-vault-item-symbol',
  userPendingRewardTokens: 'vault-vault-item-user-pending-reward-tokens',
  userStakedTokens: 'vault-vault-item-user-staked-tokens',
  dataListItem: 'vault-vault-item-data-list-item',
  withdrawFromVestingVaultModal: {
    withdrawalRequestListItem:
      'vault-vault-item-withdraw-from-vesting-vault-modal-withdrawal-request-list-item',
    availableTokens: 'vault-vault-item-withdraw-from-vesting-vault-modal-available-tokens',
  },
};

export default TEST_IDS;
